import * as React from 'react';
import { ExtensionSlot, useGlobalState, usePiletApi } from 'piral-core';
import { Breadcrumbs } from 'piral-breadcrumbs';
import { Modals } from 'piral-modals';
import { AccountInfo } from '@smapiot/components';
import { useCurrentUser } from '@piral/portal-utils';
import { Header } from './Header';
import { Content } from './Content';
import { HeaderLink, HeaderLinks, NotificationsLink, SettingsLink } from '../components';
import { logout } from '../http';
import { routes } from '../routes';

function doLogout(ev: React.SyntheticEvent) {
  ev.preventDefault();
  logout();
  return false;
}

const DefaultHeader = () => {
  return (
    <Header>
      <HeaderLinks />
      <NotificationsLink />
      <SettingsLink />
      <HeaderLink exact to={routes.logout} onClick={doLogout}>
        <i className="fas fa-sign-out-alt" />
        <span className="hamburger-only"> Logout</span>
      </HeaderLink>
    </Header>
  );
};

const Trackers: React.FC = () => {
  const trackers = useGlobalState((m) => m.registry.trackers);

  return (
    <>
      {Object.entries(trackers).map(([key, Tracker]) => (
        <Tracker key={key} />
      ))}
    </>
  );
};

const Account: React.FC = () => {
  const api = usePiletApi();
  const [, user] = useCurrentUser(api);
  const userName = user?.name;
  const userId = user?.id;
  const name = React.useRef(userId);

  if (typeof userName === 'string') {
    name.current = userName || userId;
  }

  return <AccountInfo userName={name.current} title={userId} />;
};

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  React.useEffect(() => {
    document.body.className = 'logged-in';
  }, []);

  return (
    <>
      <ExtensionSlot name="layout-header" params={{ mode: 'user' }} empty={DefaultHeader} />
      <div className="container topbar">
        <Breadcrumbs />
        <Account />
      </div>
      <Content>{children}</Content>
      <Trackers />
      <Modals />
      <ExtensionSlot name="layout-footer" params={{ mode: 'user' }} />
    </>
  );
};
